const Rdata = [
    {
        img:"https://media.glassdoor.com/sqls/2862211/noi-technologies-squareLogo-1626334103462.png",
        rating:2.0,
        position:"Full Stack Web Developer",
        company:"CIMET",
        location:"Jaipur, Rajasthan",
        id:1
    },
    {
        img:"https://media.glassdoor.com/sqlm/4008222/uws-india-squarelogo-1620394641114.png",
        rating:4.4,
        position:"ReactJS Developer - Full Stack Developer (Australian Company)",
        company:"Macayla Education & Placement Services",
        location:"Jaipur, Rajasthan",
        id:2
    },
    {
        img:"https://media.glassdoor.com/sql/623858/kamal-cogent-energy-squarelogo-1427198408911.png",
        rating:3.2,
        position:"Full Stack Laravel/PHP Developer",
        company:"UWS (India)",
        location:"Jaipur, Rajasthan",
        id:3
    },
    {
        img:"https://media.glassdoor.com/sqlm/4008222/uws-india-squarelogo-1620394641114.png",
        rating:4.4,
        position:"ReactJS Developer - Full Stack Developer (Australian Company)",
        company:"Macayla Education & Placement Services",
        location:"Jaipur, Rajasthan",
        id:4
    },
    {
        img:"https://media.glassdoor.com/sqls/2862211/noi-technologies-squareLogo-1626334103462.png",
        rating:2.0,
        position:"Full Stack Web Developer",
        company:"CIMET",
        location:"Jaipur, Rajasthan",
        id:5
    }
    
]

export default Rdata;